export default __webpack_public_path__ + "static/media/miguel-lopes-7.ef847838.jpg";